import { useTranslation } from 'react-i18next';

interface QueryErrorMessageProps {
  error: Error;
}

export function QueryErrorMessage({ error }: QueryErrorMessageProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <p className="p-6 text-center text-destructive">
      {t('common.error')}: {error.message}
    </p>
  );
}
